import { render, staticRenderFns } from "./nav-section.vue?vue&type=template&id=a21130a0&scoped=true"
import script from "./nav-section.vue?vue&type=script&lang=js"
export * from "./nav-section.vue?vue&type=script&lang=js"
import style0 from "./nav-section.vue?vue&type=style&index=0&id=a21130a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21130a0",
  null
  
)

export default component.exports